<template>
  <v-row>
    <v-col cols="1" class="py-0">
      <v-checkbox
        class="mr-5"
        v-model="checkbox"
        :disabled="disabled"
        @change="onCheckboxClicked($event)"
      ></v-checkbox>
    </v-col>
    <v-col cols="11" class="py-0">
      <paragraph><slot></slot></paragraph>
      <v-textarea
        :label="label"
        v-model="localVal"
        :disabled="!checkbox"
        counter="750"
        :rows="1"
        auto-grow
        @input="$emit('update:value', localVal)"
        class="pt-0 mt-0"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import Paragraph from "@/components/ui/Paragraph.vue";
export default {
  name: "TextAreaWithCheckbox",
  components: { Paragraph },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkbox: false,
      localVal: ""
    };
  },
  watch: {
    value(newVal) {
      this.localVal = newVal;
    },
    checked(newVal) {
      this.checkbox = newVal;
    }
  },
  methods: {
    onCheckboxClicked(val) {
      this.$emit("update:checked", val);
      if (!val) {
        this.$emit("update:value", "");
      }
    }
  }
};
</script>
